var $b380803f07471da0$exports = {};
$b380803f07471da0$exports = {
    "valid": `\u{6709}\u{6548}`
};


export {$b380803f07471da0$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
